import { HTTP_CODE, ERROR_HANDLING_EXPERIENCE } from '../../utils/redirector-utils';

export const hasNoMetadata = ({ data, collectionId }) => {
  if (!data) return null;

  if (!(collectionId && data?.collection?.metadata)) {
    return {
      shouldRedirect: false,
      isErrorStatus: true,
      httpCode: HTTP_CODE.NOT_FOUND,
      description: 'no collection metadata found',
      errorHandlingExperience: ERROR_HANDLING_EXPERIENCE.GENERIC
    };
  }

  return null;
};

export const isValidCanonical = ({ data, path }) => {
  if (!data) return null;
  const { canonicalUrl } = data?.collection?.metadata || {};

  if (!canonicalUrl) return null;

  if (canonicalUrl !== path && canonicalUrl === encodeURI(canonicalUrl)) {
    return {
      shouldRedirect: true,
      httpCode: HTTP_CODE.PERM_REDIRECT,
      redirectPath: canonicalUrl,
      description: 'redirected for collectioins canonical url'
    };
  }

  if (canonicalUrl !== path) {
    console.log('canonicalUrl was not valid; redirect bypassed');
  }

  return null;
};
